/**
 * DataElementsApi
 * DataElementsApi
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SystemInfo { 
    systemName?: string;
    description?: string;
}


export const SystemInfoProps = {
  systemName: 'systemName',
  description: 'description',
} as const;

